import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { getParsedValue, isNullOrUndefined } from '../../../utils/general'

export default class InputNumberField extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    fieldName: PropTypes.string,
    fieldValue: PropTypes.number,
    required: PropTypes.bool.isRequired,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onChange: PropTypes.func.isRequired,
    linked: PropTypes.bool,
    linkedTrueMessage: PropTypes.string,
    linkedFalseMessage: PropTypes.string,
    onChangeChain: PropTypes.func,
    step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fieldOnlyBoolean: PropTypes.bool,
    readOnly: PropTypes.bool,
    positiveNoDecimal: PropTypes.bool
  }

  render() {
    return (
      <div className="group">
        {!this.props.fieldOnlyBoolean ? (
          <label className={`header ${this.props.error ? 'error' : ''}`} htmlFor={this.props.name}>
            {this.props.name ? this.props.name : null}
            {this.props.required ? ' *' : null}
          </label>
        ) : null}
        <div className="input-wrapper">
          {this.props.positiveNoDecimal ? (
            <input
              className={`input-field ${this.props.error ? 'error' : null} ${
                this.props.linked !== undefined ? 'linked-field-input' : ''
              }`}
              value={!isNullOrUndefined(this.props.fieldValue) ? this.props.fieldValue : ''}
              onChange={this.onChange}
              id={this.props.name}
              type="text"
              pattern="[0-9]"
              title={this.props.title}
              step={this.props.step ? this.props.step : 1}
              min={0}
              disabled={this.props.readOnly === true}
            />
          ) : (
            <input
              className={`input-field ${this.props.error ? 'error' : null} ${
                this.props.linked !== undefined ? 'linked-field-input' : ''
              }`}
              value={!isNullOrUndefined(this.props.fieldValue) ? this.props.fieldValue : ''}
              onChange={this.onChange}
              id={this.props.name}
              type="number"
              title={this.props.title}
              step={this.props.step ? this.props.step : 1}
              min={0}
              disabled={this.props.readOnly === true}
            />
          )}
          {this.props.readOnly !== true ? <div className="linked-field">{this.renderLinkedField()}</div> : null}
        </div>
        {this.props.error && typeof this.props.error === 'string' && (
          <div className="input-error-message">{this.props.error}</div>
        )}
      </div>
    )
  }

  renderLinkedField = () => {
    if (this.props.linked === undefined || this.props.linked === null) {
      return null
    }

    if (this.props.linked) {
      return (
        <i
          className="fa fa-link"
          aria-hidden="true"
          title={this.props.linkedTrueMessage}
          onClick={() => this.props.onChangeChain(false)}
        />
      )
    } else {
      return (
        <i
          className="fa fa-unlink"
          aria-hidden="true"
          title={this.props.linkedFalseMessage}
          onClick={() => this.props.onChangeChain(true)}
        />
      )
    }
  }

  onChange = event => {
    const val = event.target.value
    if (this.props.positiveNoDecimal) {
      if (!/\d+$/.test(val)) {
        if (event.target.value === '') {
          const value = getParsedValue(val)
          return this.props.onChange(value, this.props.fieldName)
        }
        return null
      }
    }

    const value = getParsedValue(val)

    return this.props.onChange(value, this.props.fieldName)
  }
}
